/**
 * @Author: Zero
 * @Date: 2024-10-09 15:23:49
 * @Explain: 所有国家旗帜的 SVG 图标集合
 */
import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { useMemo } from 'react';
// style
import 'flag-icons/css/flag-icons.min.css';
// components
import { Icon } from '@/components/tdesign';

type FlagIconsCountryType = {
  capital: string;
  code: string;
  continent: string;
  flag_1x1: string;
  flag_4x3: string;
  iso: boolean;
  name: string;
};
type PropsType = {
  countryCode: string;
  className?: string;
  style?: CSSProperties;
  iconName?: string;
  iconColor?: string;
};
// 备注：若flag-icons插件版本更新需及时更新插件支持的国家相关配置信息
const countryJson: FlagIconsCountryType[] = require('./country.json');

const FlagIcon = (props: PropsType) => {
  const {
    countryCode,
    className = '',
    iconColor = '#D9D9DF',
    iconName = 'contact-report-nolocation',
    style = {
      width: '24px',
    },
  } = props;
  // 传入国家编码是否在全球所有国家的国旗插件范围内
  const hasSameCountry = useMemo(
    () =>
      countryJson.some(
        (item: FlagIconsCountryType) => item.code === countryCode,
      ),
    [countryCode, countryJson],
  );

  return hasSameCountry ? (
    <span
      style={style}
      className={`flag-icon fi fi-${countryCode} ${className}`}
    ></span>
  ) : (
    <Icon.Font
      style={style}
      name={iconName}
      color={iconColor}
      className={classNames('default-flag-icon', className)}
    />
  );
};

export default FlagIcon;
